import React, { useRef, useState, useEffect, useCallback } from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';

import AssetCarouselSlide from './AssetCarouselSlide';
import './AssetCarousel.scss';
import { useScreenSize } from '../../../helpers';

/**
 * Asset Carousel
 *
 * @param {*} param0
 * @returns
 */
const AssetCarousel = ({ data }) => {
    const { logicalName, slides } = data;
    const [loaded, setLoaded] = useState(false);

    const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
    const { isMobileScreen } = useScreenSize();

    useEffect(() => {
        (() => {
            // update slick-arrow class
            document.querySelectorAll('.asset-carousel .slick-slider .slick-arrow').forEach(item => {
                item.classList.add(`slides-format-${data.slides.length}`);
            });
        })();
    }, []);

    const sliderRef = useRef();

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        lazyLoad: true,
        autoplay: true,
        autoplaySpeed: 5000,
    };

    const pageDotClick = useCallback(s => () => {
        sliderRef.current.slickGoTo(s);
    });

    const handleAfterChange = useCallback(index => {
        setCurrentSlideIndex(index);
    });

    const handleInit = useCallback(() => {
        setTimeout(() => {
            setLoaded(true);
        }, 0);
    });

    const dotMargin = isMobileScreen ? 'mx-3' : 'tw-mx-[26px]';

    return (
        <div className="module asset-carousel" id={logicalName}>
            <div className="tw-container tw-mx-auto" tabIndex={-1}>
                <Slider
                    {...settings}
                    ref={sliderRef}
                    onInit={handleInit}
                    beforeChange={handleAfterChange}
                    afterChange={handleAfterChange}
                    pauseOnHover={true}
                    className="tw-relative"
                >
                    {slides.map((slide, i) => (
                        <AssetCarouselSlide key={i} {...slide} />
                    ))}
                </Slider>

                <div className="tw-flex tw-justify-center tw-items-center tw-my-5">
                    <div className="tw-flex-1 tw-flex tw-justify-center">
                        {loaded &&
                            sliderRef.current.props.children.map((sld, index) => (
                                <button
                                    className={
                                        `hover:tw-bg-dark-blue tw-transition tw-border tw-b-1 tw-border-dark-blue tw-rounded-full tw-text-dark-blue ${dotMargin} ` +
                                        `${index == currentSlideIndex ? 'tw-bg-dark-blue' : ''}`
                                    }
                                    style={{ height: '15px', width: '15px' }}
                                    onClick={pageDotClick(index)}
                                    key={index}
                                    aria-label={`Go to slide ${index + 1}`}
                                />
                            ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AssetCarousel;

const ButtonPropTypes = {
    buttonTitle: PropTypes.string,
    buttonLink: PropTypes.string,
};

const SlidePropTypes = {
    title: PropTypes.string,
    bannerImage: PropTypes.string,
    mobileBannerImage: PropTypes.string,
    publishDateAndTime: PropTypes.string,
    readTime: PropTypes.string,
    shortDescription: PropTypes.string,
    articleType: PropTypes.string,
    postType: PropTypes.string,
    tagging: PropTypes.string,
    isDarkMode: PropTypes.bool,
    button: PropTypes.shape(ButtonPropTypes),
    assetTarget: PropTypes.string,
    seoTitle: PropTypes.string,
    publishDateTime: PropTypes.number,
    logicalName: PropTypes.string,
};

const AssetCarouselPropTypes = {
    name: PropTypes.string,
    data: PropTypes.shape({
        articleType: PropTypes.string,
        timedTransition: PropTypes.string,
        categoryTagging: PropTypes.arrayOf(PropTypes.string),
        postType: PropTypes.string,
        tags: PropTypes.string,
        slides: PropTypes.arrayOf(PropTypes.shape(SlidePropTypes)),
        assetLogicalName: PropTypes.string,
        logicalName: PropTypes.string,
    }),
};

AssetCarousel.propTypes = AssetCarouselPropTypes;
